<template>
  <div class="registration-complete-template" theme>
    <div id="theme-registration-complete" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      path: 'registration',
      parts: [
        {
          elem: '#theme-registration-complete',
          htmlFile: 'complete'
        }
      ]
    }
  },
  mounted() {
    if (this.loggedInUser) {
      this.openLink('/')
    }
  }
}
</script>
